<template>
    <div class="flex gap-2">
        <v-btn icon text color="teal" @click="$emit('downloadProforma', idProforma)">
            <v-icon>mdi-cloud-download</v-icon>
        </v-btn>

        <v-dialog v-model="showDeleteModal" max-width="400px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="['admin', 'superuser'].includes(userRole)" icon text color="gray" v-bind="attrs" v-on="on">
                    <v-icon>delete_forever</v-icon>
                </v-btn>
            </template>
            <v-card class="p-8">
                <v-card-title>
                    Sterge definitiv proforma nr. {{ idProforma }}?
                </v-card-title>
                <div class="flex flex-row justify-end gap-2">
                    <v-btn color="blue-grey" class="uppercase" large dark
                        @click="showDeleteModal = false">Anuleaza</v-btn>
                    <v-btn color="red" class="uppercase" large dark @click="$emit('deleteProforma', idProforma)">
                        <v-icon left dark>
                            mdi-delete
                        </v-icon>
                        Sterge
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        idProforma: String,
        userRole: String
    },
    data() {
        return {
            showDeleteModal: false
        }
    }
}
</script>